// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1561":"e9b1b71c","5412":"868af789"}[chunkId] + ".chunk.css";
};